import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { DepartmentService } from '../../services/jrni/department.service';
import { ServicesService } from '../../services/jrni/services.service';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { BasketService } from '../../services/jrni/basket.service';
import { MemberService } from '../../services/jrni/member.service';
import {
	UntypedFormGroup,
	UntypedFormBuilder,
	Validators,
	UntypedFormControl,
	FormGroup,
	FormControl,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatastoreService } from '../../services/datastore.service';
import {
	availableSlotsForDisplay,
	citizenshipAttendeesAnswer,
	citizenshipCapacityOutcome,
	citizenshipPartySize,
} from '../../services/citizenship-capacity';
import { AppConfig } from '../../app.config';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AlertService } from '../../_alert';
import { _, TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../services/jrni/api.service';
import moment from 'moment-timezone';
import { QuestionsService } from '../../services/questions.service';
import { CivicaService } from '../../services/civica.service';
import * as generator from 'generate-password-browser';
import { BehaviorSubject, map } from 'rxjs';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { schema } from '@angular-devkit/core';
@Component({
	selector: 'app-summary',
	templateUrl: './summary.component.html',
	styleUrls: ['./summary.component.scss'],
})
export class SummaryComponent implements OnInit {
	selectedDepartment;
	selectedLocation;
	selectedService;
	pageTitle: string;
	summaryPageText: string;
	selectedSlot;
	selectedResource;
	selectedResourceObj;
	endSlot;
	termsAndConditions;
	submitted = false;
	items;
	member;
	client;
	address;
	lat;
	long;
	config: any;
	bookingQuestions = [];
	filterSummaryData = [];
	bookingAnswers = [];
	displayTnCs: boolean;
	bookingSummaryData = [];
	companySummaryData = [];
	bookingQuestionSchema: any;
	costBreakDown = [];
	total = 0;
	extraDetailsPresent = false;
	slotAvailable = true;
	dateOfBirth = '';
	checkoutStarted = false;
	// Set when the group citizenship ceremony can no longer seat this party. Drives the
	// notification banner on this page — see citizenshipCapacityStillHolds().
	citizenshipCapacityFull = false;
	citizenshipCapacitySpaces = 0;
	citizenshipCapacityRequired = 0;

	checkoutFailed = false;
	adminJourney = false;
	adminForm: UntypedFormGroup;
	adminFormSubmitted = false;
	confirmContinue = false;
	agreeDataPolicy = false;
	headerStyle: any;
	dataPolicy: string;
	dataPolicyCy: string;
	tncPolicy: string;
	store: BehaviorSubject<any>;
	addedItem: BehaviorSubject<any>;
	ceremonyFee: any;
	bookingPrice: any;
	citizenshipJourney = false;
	revealTextHeadings = [];
	agentMode: any;
	companyQuestionsForm: FormGroup;

	steps = [
		{ title: 'Booking questions', isActive: false },
		{ title: 'Choose appointment date and time', isActive: false },
		{ title: 'Your details', isActive: false },
		{ title: 'Summary', isActive: true },
		{ title: 'Confirmation', isActive: false },
	];

	meta = inject(Meta);
	constructor(
		private router: Router,
		private departmentService: DepartmentService,
		private servicesService: ServicesService,
		private availabilityService: AvailabilityService,
		private basketService: BasketService,
		private memberService: MemberService,
		private formBuilder: UntypedFormBuilder,
		private spinner: NgxSpinnerService,
		public datastoreService: DatastoreService,
		private alertService: AlertService,
		public translateService: TranslateService,
		private apiService: ApiService,
		private questionsService: QuestionsService,
		private civicaService: CivicaService
	) { }

	routerGoBack() {
		this.router.navigate(['/booking-details']);
	}

	restartJourney() {
		if (sessionStorage.getItem('journey')) {
			this.router.navigate(['start/' + sessionStorage.getItem('journey')]);
		} else {
			this.router.navigate(['/departments']);
		}
	}

	get form() {
		return this.adminForm.controls;
	}

	linkClicked(ev) {
		if (ev.target.href) {
			console.log(ev.target.href);
			window.open(ev.target.href, '_blank').focus();
			ev.preventDefault();
		}
	}

	async ngOnInit() {
		try {
			// META TAG
			this.meta.addTag({ name: 'google', content: 'nopagereadaloud' }, true);

			this.spinner.show();
			this.store = new BehaviorSubject(false);
			this.addedItem = new BehaviorSubject(false);
			this.scrollToTop();
			this.alertService.clear();

			this.agentMode = localStorage.getItem('agent');

			// COMPANY CONFIG
			let configCompanyId = AppConfig.settings.core.company_id;
			if (this.datastoreService.isCitizenshipRoute) {
				configCompanyId = AppConfig.settings.core.citizenship_company_id;
			}

			this.config = await this.apiService.getConfig(configCompanyId);
			this.headerStyle = this.config.journey_config.appointments.notificationBanner || '';
			this.revealTextHeadings = this.config.journey_config.appointments.revealTextHeadingQuestionsOnSummary;
			this.filterSummaryData = this.config.journey_config.appointments.hideQuestionsFromSummary;
			this.adminJourney = this.datastoreService.adminJourney || false;

			// RESTORE COST BREAKDOWN
			this.costBreakDown = this.datastoreService.serviceFees || [];

			// ENSURE SHARED FORM EXISTS
			if (!this.datastoreService.companyQuestionsForm) {
				this.datastoreService.companyQuestionsForm = new FormGroup({});
			}
			this.companyQuestionsForm = this.datastoreService.companyQuestionsForm;

			// CUSTOMER DETAILS
			this.client = this.datastoreService.customerDetailsForm?.getRawValue() || {};

			// FETCH COMPANY
			const company = await this.servicesService.get();
			if (!company) return this.restartJourney();

			// FETCH LOCATION
			this.selectedLocation = await this.departmentService.getLocation();
			this.address = this.selectedLocation?.address || '';
			this.datastoreService.address = this.address;

			// FETCH RESOURCE
			this.selectedResource = await this.availabilityService.getSelectedResource();
			this.selectedResourceObj = await this.availabilityService.getSelectedResourceObj();

			// FETCH SLOT
			if (this.datastoreService.selectedSlot) {
				this.selectedSlot = await this.availabilityService.getSelectedSlot();
				this.endSlot = await this.availabilityService.getEndSlot();
			}

			// EXTRACT DOB FROM ANY KNOWN FIELD IDS
			const dobFieldIds = ['1', '279', '34'];
			for (const id of dobFieldIds) {
				if (this.datastoreService.customerDetailsForm?.controls[id]?.value) {
					this.dateOfBirth = this.getDOB(this.datastoreService.customerDetailsForm.controls[id].value);
					break; // stop at first found
				}
			}

			// FETCH DEPARTMENT
			this.selectedDepartment = await this.departmentService.get();
			if (!this.selectedDepartment) return this.restartJourney();

			if (this.selectedDepartment.extra) {
				if (this.adminJourney) {
					this.dataPolicy = `Advise the customer that they can see our Privacy Policy for details...`;
				} else {
					this.dataPolicy = this.selectedDepartment.extra.privacy_statement_text || 'data policy not set';
					this.dataPolicyCy = this.selectedDepartment.extra.privacy_statement_text_welsh || 'Welsh data policy not set';
				}
				this.pageTitle = this.selectedDepartment.extra.review_page_title || 'Review title not set';
				this.summaryPageText = this.selectedDepartment.extra.summary_page_text || '';
				this.getTermsAndConditions();
			}

			// FETCH LOCATION AGAIN (if needed)
			this.selectedLocation = await this.departmentService.getLocation();

			// FETCH SELECTED SERVICE
			this.selectedService = await this.servicesService.get();
			if (this.selectedService) {
				this.selectedService.calculated_duration =
					Number(this.datastoreService.extraDuration) +
					Number(this.selectedService.durations[0]);
			}

			// BUILD BOOKING SUMMARY
			this.bookingSummaryData = this.buildBookingSummary();

			// CALCULATE TOTAL
			this.calculateTotal();

			// ADMIN FORM
			if (this.adminJourney) this.initAdminForm();
		} catch (error) {
			console.error('Error initializing page', error);
		} finally {
			// ALWAYS hide spinner
			this.spinner.hide();
		}
	}

	private buildBookingSummary() {
		const selectedSchema = this.datastoreService.selectedSchema;
		this.bookingQuestionSchema = this.datastoreService.serviceQuestionSchema[selectedSchema];
		const formValues = JSON.parse(
			sessionStorage.getItem('form_builder_answers') || '{}'
		);

		const buildEntry = (question, answer, prettyAnswer) => ({
			name: this.resolveBindings(question.title, formValues[selectedSchema]),
			answer: prettyAnswer || answer,
			detail_type: question.type,
			price: 0,
			reference: question.field,
			question_id: question.field,
		});

		return this.bookingQuestionSchema.schema.fields
			.map((question) => {
				const id = question.field;
				const rawAnswer = formValues[selectedSchema][id];

				// Get the pretty answer based on question type
				let prettyAnswer = rawAnswer;

				if (question.type === 'radio' && question.radio_options) {
					const option = question.radio_options.find(opt => opt.value === rawAnswer);
					prettyAnswer = option ? option.title : rawAnswer;
				} else if (question.type === 'dropdown' && question.options) {
					const option = question.options.find(opt => opt.value === rawAnswer);
					prettyAnswer = option ? option.title : rawAnswer;
				} else if (question.type === 'checkbox') {
					prettyAnswer = (rawAnswer === true || rawAnswer === '*') ? 'Yes' : 'No';
				}

				return buildEntry(question, rawAnswer, prettyAnswer);
			})
			// Filter out headings, questions without answers, and items in filterSummaryData
			.filter((item) => {
				// Remove headings
				if (item.detail_type === 'heading') {
					return false;
				}

				if (item.detail_type === 'checkbox') {
					return false;
				}

				// Remove questions without answers (null, undefined, empty string)
				if (item.answer === null || item.answer === undefined || item.answer === '') {
					return false;
				}

				// Remove items in the filter list
				if (this.filterSummaryData.includes(item.question_id)) {
					return false;
				}

				return true;
			});
	}

	private resolveBindings(
		text: string,
		values: Record<string, any>
	): string {
		if (!text) return text;

		return text.replace(/\{([^}]+)\}/g, (_, reference) => {
			const value = values[reference];

			// fallback if missing
			if (value === undefined || value === null || value === '') {
				return '';
			}

			return String(value);
		});
	}

	private calculateTotal() {
		const paidItems = this.bookingSummaryData.filter(item => item.detail_type === 'check-price');
		this.total = (paidItems.map(i => i.price).reduce((a, b) => a + b, 0) || 0) + (this.selectedService?.price || 0);
		this.extraDetailsPresent = this.bookingSummaryData.some(i => i.detail_type !== 'check-price');
	}

	private initAdminForm() {
		this.adminForm = new FormGroup({
			amount: new FormControl('', Validators.required),
			reference: new FormControl('', Validators.required),
			certificate_removal: new FormControl(''),
			note: new FormControl('', Validators.required),
		});
	}


	getDOB(dateString) {
		const birthDate = new Date(dateString);
		return moment(birthDate).format('DD/MM/YYYY');
	}

	getTermsAndConditions() {
		if (this.selectedDepartment.hasOwnProperty('extra')) {
			this.displayTnCs = true;
			// Check if the terms and conditions are on/off
			if (
				this.selectedDepartment.extra.hasOwnProperty('display_tncs') &&
				this.selectedDepartment.extra.display_tncs.toLowerCase() === 'yes'
			) {
				this.termsAndConditions = '';
				// Loop through all the extra pre defined fields
				const extraQuestions = this.selectedDepartment.extra;
				for (const key in extraQuestions) {
					if (extraQuestions.hasOwnProperty(key)) {
						const element = extraQuestions[key];
						if (key.indexOf('terms_and_conditions') >= 0) {
							if (!this.termsAndConditions) {
								this.termsAndConditions += element;
							} else {
								this.termsAndConditions += ' ' + element;
							}
						}
					}
				}
			} else {
				this.displayTnCs = false;
			}
		}
	}

	// create client
	async createClient(adminJourney: boolean): Promise<boolean> {
		const customerQs = [];
		let clientCreated = false;

		// For each question in the form check if the customer question exists and if so add to customerAnswers []
		for (const control in this.datastoreService.customerDetailsForm.value) {
			if (
				this.datastoreService.customerDetailsForm.value.hasOwnProperty(control)
			) {
				const element =
					this.datastoreService.customerDetailsForm.value[control];
				const question = this.datastoreService.customerQuestions.filter(
					(question) => question.id.toString() === control
				);
				let q = {};
				if (question.length > 0 && element !== '') {
					q = {
						id: question[0].id,
						answer: element,
					};

					customerQs.push(q);
				}
			}
		}

		const customerDetailsValue = this.datastoreService.customerDetailsForm;

		const params = {
			first_name: customerDetailsValue.controls.first_name.value,
			last_name: customerDetailsValue.controls.last_name.value,
			email: customerDetailsValue.controls.email_address.value,
			mobile: customerDetailsValue.controls.contact_number.value,
			// mobile: customerDetailsValue.controls.mobile_number.value,
			// postcode: customerDetailsValue.postcode,
			// .trim()
			// .replace(" ", ""),
			member_type: '2',
			send_welcome_email: false,
		};

		let clientRes: any;
		const found: any = await this.apiService.getBookingsForUser(
			this.selectedLocation,
			this.selectedDepartment,
			params.email
		);

		if (adminJourney) {
			// we DO NOT need to create a client in this instance.
			try {
				if (found !== 'User not found') {
					this.datastoreService.client = found;
					console.log(
						'datastore client (pre-existing member ADMIN)',
						this.datastoreService.client
					);
					this.datastoreService.clientCreated = true;
				} else {
					clientRes = await this.selectedDepartment.$post('client', {}, params);
					if (clientRes) {
						this.datastoreService.client = clientRes;
						console.log(
							'datastore client (newly created ADMIN)',
							this.datastoreService.client
						);
						this.datastoreService.clientCreated = true;
						clientCreated = true;
					}
				}
				this.store.next(true);
				return clientCreated;
			} catch (err) {
				console.error(err);
			}
		} else {
			try {
				if (found !== 'User not found') {
					// now we sso if the are a member
					if (found.member_type && found.member_type == 2) {
						try {
							const currentAuthToken = localStorage.getItem('auth_token');
							if (currentAuthToken) {
								localStorage.setItem('_original_auth_token', currentAuthToken);
							}
							clientRes = await this.selectedDepartment.$post(
								'client',
								{},
								params
							);
							if (clientRes) {
								this.datastoreService.client = clientRes;
								this.member = clientRes;
								console.log('datastore client', this.datastoreService.client);
								this.datastoreService.clientCreated = true;
								const newAuthToken = localStorage.getItem('auth_token');
								localStorage.setItem('auth_token', newAuthToken);
								clientCreated = true;
							}
						} catch (err) {
							console.error(err);
						}
					} else {
						// Now we need to SSO them in!
						// const deleted:any = await this.apiService.deleteBaskets(this.selectedDepartment);
						// await this.apiService.deleteServiceItem(this.selectedLocation, this.basketService.currentBasket, this.basketService.currentServiceItem);
						await this.apiService.deleteBaskets(this.selectedLocation);
						const currentAuthToken = localStorage.getItem('auth_token');
						if (currentAuthToken) {
							localStorage.setItem('_original_auth_token', currentAuthToken);
						}
						const token: any = await this.apiService.generateSSOToken(
							this.selectedDepartment.id,
							params.first_name,
							params.last_name,
							params.email
						);
						console.log(token);
						clientRes = (await this.apiService.ssoLogin(
							this.selectedDepartment.id,
							token.token
						)) as any;
						this.datastoreService.client = clientRes._embedded.members[0];
						this.member = this.datastoreService.client;
						localStorage.setItem('auth_token', clientRes.auth_token);
						clientCreated = true;
					}
				} else {
					clientRes = await this.selectedDepartment.$post('client', {}, params);
					if (clientRes) {
						this.datastoreService.client = clientRes;
						this.member = clientRes;
						console.log(
							'datastore client (newly created NON-ADMIN)',
							this.datastoreService.client
						);
						this.datastoreService.clientCreated = true;
						clientCreated = true;
					}
				}
				this.store.next(true);
			} catch (err) {
				console.error(err);
			}
		}
		return clientCreated;
	}

	async addItem() {
		// Get the selected slot from the previous page
		const selectedSlot = await this.availabilityService.getSelectedSlot();
		console.log('selectedSlot', selectedSlot);

		// from the config, get the question ID for the data policy
		const dataPolicyQuestionId = this.config.journey_config.appointments.privacyConsent.bookingProfile;

		console.log(`${dataPolicyQuestionId} - ${this.agreeDataPolicy}`);

		this.bookingAnswers.push({
			id: `${dataPolicyQuestionId}`,
			answer: this.agreeDataPolicy ? true : null,
		});

		// Get the booking answers and add them to an array ready to add to basket
		for (const key in this.datastoreService.bookingForm.value) {
			{
				this.bookingAnswers.push({
					id: key,
					answer: this.datastoreService.bookingForm.value[key],
				});
			}
		}

		for (const key in this.datastoreService.companyQuestionsForm.value) {
			{
				const isAuxPostcode = key.startsWith('postcode_') || (key.endsWith('_postcode') && key.slice(0, -9) in this.datastoreService.companyQuestionsForm.value);
				if (!isAuxPostcode) {
					this.bookingAnswers.push({
						id: key,
						answer: this.datastoreService.companyQuestionsForm.value[key],
					});
				}
			}
		}

		for (const key in this.datastoreService.companyAnswers.value) {
			{
				if (!key.includes('postcode')) {
					// ditch any postcode lookups
					this.bookingAnswers.push({
						id: key,
						answer: this.datastoreService.companyAnswers.value[key],
					});
				}
			}
		}

		// add the extra questions from the departments page
		// we do all this because we get the answers to several questions before we know the service
		//so we need to convert the base service's questions too the alt ones, and the only shared identifier (that we can access) is name
		if (this.datastoreService.companyQuestions) {
			for (const key in this.datastoreService.companyQuestionsForm.value) {
				const myQuestion = this.datastoreService.companyQuestions.filter(
					(x) => x.id.toString() === key
				)[0];
				// const myALtQuestion = altQuestions.questions.filter(x => x.name === myQuestion.name)[0]
				if (myQuestion) {
					if (myQuestion.length > 0) {
						this.bookingAnswers.push({
							id: key,
							answer: this.datastoreService.companyQuestionsForm.value[key],
						});
					}
				}

			}
		}

		this.datastoreService.bookingAnswers = this.bookingAnswers;

		if (this.datastoreService.adminJourney) {
			try {
				const updateServiceItem = await this.basketService.updateItemV1(
					this.selectedLocation,
					this.selectedService.id,
					this.selectedService.calculated_duration,
					selectedSlot.start,
					// this.bookingAnswers,
					this.datastoreService.client.id,
					this.selectedResource,
					this.datastoreService.staff_set
				);
				console.log(updateServiceItem);
				// api.service swallows HTTP failures and returns the error message as a STRING
				// instead of throwing, so a failed update reads as success here. Anything that is
				// not a service item means the item still carries the resource JRNI auto-assigned
				// — i.e. the wrong room — so fail loudly rather than paying for it.
				if (!updateServiceItem || typeof updateServiceItem !== 'object') {
					throw new Error(
						`Service item update failed: ${JSON.stringify(updateServiceItem)}`
					);
				}
				this.addedItem.next(updateServiceItem);
			} catch (err) {
				console.error(err);
				this.alertService.error(
					this.translateService.instant('SUMMARY.INVALID_SLOT')
				);
				this.spinner.hide();
				this.scrollToTop();
				throw err;
			}
		} else {
			try {
				const basket: any = await this.basketService.getCurrentBasket(
					this.selectedLocation
				);
				console.log('FOUND BASKET', basket);
				if (!basket) {
					// if no baskets on new auth token, create one then add the service item
					this.apiService
						.createBasket(this.selectedLocation)
						.subscribe(async (response) => {
							console.log('newBasket', response.body);
							const serviceItem: any = await this.apiService.addServiceItem(
								this.selectedLocation,
								response.body,
								this.selectedSlot.start,
								this.selectedService,
								this.bookingAnswers,
								this.selectedService.calculated_duration,
								this.selectedResource
							);
							console.log(
								'newBasket',
								response.body,
								'serviceItem',
								serviceItem
							);
							this.basketService.currentBasket = response.body;
							this.basketService.currentServiceItem = serviceItem;
							// api.service swallows HTTP failures and returns the error message as a STRING
							// instead of throwing, so a failed update reads as success here. Anything that is
							// not a service item means the item still carries the resource JRNI auto-assigned
							// — i.e. the wrong room — so fail loudly rather than paying for it.
							if (!serviceItem || typeof serviceItem !== 'object') {
								throw new Error(
									`Service item update failed: ${JSON.stringify(serviceItem)}`
								);
							}
							this.addedItem.next(serviceItem);
						});
				} else {
					const updateServiceItem = await this.apiService.updateServiceItem(
						this.selectedLocation,
						this.basketService.currentBasket,
						this.basketService.currentServiceItem,
						{
							company_id: this.selectedLocation.id,
							service_id: this.selectedService.id,
							duration: this.selectedService.calculated_duration,
							person_id: this.datastoreService.staff_set,
							start: `${selectedSlot.start}`,
							resource_id: this.apiService.resolveResourceId(this.selectedResource),
							// questions: this.bookingAnswers,
						}
					);
					console.log(updateServiceItem);
					// api.service swallows HTTP failures and returns the error message as a STRING
					// instead of throwing, so a failed update reads as success here. Anything that is
					// not a service item means the item still carries the resource JRNI auto-assigned
					// — i.e. the wrong room — so fail loudly rather than paying for it.
					if (!updateServiceItem || typeof updateServiceItem !== 'object') {
						throw new Error(
							`Service item update failed: ${JSON.stringify(updateServiceItem)}`
						);
					}
					this.addedItem.next(updateServiceItem);
				}
			} catch (err) {
				console.error(err);
				this.alertService.error(
					this.translateService.instant('SUMMARY.INVALID_SLOT')
				);
				this.spinner.hide();
				this.scrollToTop();
				throw err;
			}
		}
	}

	/**
	 * Re-check that the group citizenship ceremony can still seat this party.
	 *
	 * The calendar checked it when the slot was chosen, but filling in the details takes
	 * minutes and the places are shared with everyone else booking that ceremony. The next
	 * thing this page does is write the pre-basket row and hand the customer to the payment
	 * gateway, after which the booking is made server-side whether or not the ceremony can
	 * seat them — so this is the last point at which a shortfall costs nobody anything.
	 *
	 * A shortfall is not an error. It is a fact about the ceremony with an obvious way
	 * forward, so it is rendered as a notification banner on this page instead of going
	 * through alertService, whose summary is headed "There is a problem" — wording that
	 * alarms applicants and tells them nothing they can act on.
	 */
	private async citizenshipCapacityStillHolds(): Promise<boolean> {
		this.citizenshipCapacityFull = false;

		if (
			!this.datastoreService.isCitizenshipRoute ||
			!this.datastoreService.groupCitizenshipBooking
		) {
			return true;
		}

		// The calendar strips the UTC offset before asking, and claim rows are matched to
		// the minute, so the same string has to go out from here.
		const slotStart = `${this.selectedSlot?.start || ''}`.split('+')[0];
		if (!slotStart || !this.selectedLocation?.id || !this.selectedService?.id) {
			// Nothing to ask about. The calendar has already gated this slot once, so let the
			// journey carry on rather than refuse a payment over missing local state.
			console.warn('[citizenship-capacity] summary re-check skipped', {
				slotStart,
				location: this.selectedLocation?.id,
				service: this.selectedService?.id,
			});
			return true;
		}

		const requiredPlaces = this.citizenshipPlacesRequired();

		let availability: any;
		this.spinner.show();
		try {
			availability = await this.apiService.citizenshipAvailability(
				this.selectedLocation.id,
				this.selectedService.id,
				slotStart
			);
		} catch (err) {
			console.error('[citizenship-capacity] summary re-check failed', err);
			this.spinner.hide();
			return true;
		}
		this.spinner.hide();

		const outcome = citizenshipCapacityOutcome(availability, requiredPlaces);
		console.log('[citizenship-capacity] summary re-check', {
			requiredPlaces,
			availability,
			outcome,
		});

		// 'unknown' means citizenshipAvailability handed back its error message instead of a
		// slot count. A request that failed is not a ceremony that is full, so say nothing.
		if (outcome !== 'full') {
			return true;
		}

		this.citizenshipCapacitySpaces = availableSlotsForDisplay(availability);
		this.citizenshipCapacityRequired = requiredPlaces;
		this.citizenshipCapacityFull = true;
		// Drop any "There is a problem" summary left over from an earlier attempt, so the
		// banner is the only thing the customer has to read.
		this.alertService.clear();
		this.scrollToTop();
		// Scrolling alone tells a screen reader nothing, and Angular has not rendered the
		// banner yet — move the reading position onto it once it exists.
		setTimeout(() => document.getElementById('citizenship-capacity-banner')?.focus(), 0);
		return false;
	}

	/** Places this booking needs, counted the way the calendar counts them. */
	private citizenshipPlacesRequired(): number {
		return citizenshipPartySize(
			citizenshipAttendeesAnswer(this.datastoreService.selectedSchema)
		).places;
	}

	/** Back to the calendar, to choose a time that still has room. */
	chooseAnotherDateAndTime() {
		this.citizenshipCapacityFull = false;
		this.router.navigate(['/calendar']);
	}

	async startCheckout(telephony: boolean) {
		// Take the buttons out before the first await. The re-check below makes a request,
		// and until this is set a second click would start a second checkout.
		this.checkoutStarted = true;

		// The ceremony can fill up while the customer is filling in their details, and
		// everything past this point commits them — see citizenshipCapacityStillHolds().
		if (!(await this.citizenshipCapacityStillHolds())) {
			// Places can free up again, so leave the customer able to try this slot once
			// more as well as able to pick another one.
			this.checkoutStarted = false;
			return;
		}

		if (this.adminJourney) {
			this.submitted = true;
			if (!telephony) {
				// if (this.adminForm.valid) { // Admin form no longer in the code
				// do some admin stuff
				this.checkoutStarted = true;
				this.spinner.show();

				// Check if selected slot is still available
				let slotAvailable: boolean;

				await this.apiService
					.checkSlotAvailability(
						this.selectedDepartment,
						this.selectedSlot.start
					)
					.then((res: any) => {
						slotAvailable = res.available;
					});

				if (slotAvailable === false) {
					// If unavailable, then alert user
					this.alertService.error(
						this.translateService.instant('SUMMARY.INVALID_SLOT')
					);
					this.scrollToTop();
					this.slotAvailable = false;
					this.spinner.hide();
					this.checkoutStarted = false;
				} else {
					// If available then checkout
					// this.checkout()
					if (!telephony) {
						await this.adminCheckout();
					}
				}
				// }
			} else {
				this.checkoutStarted = true;
				this.spinner.show();

				// Check if selected slot is still available
				let slotAvailable: boolean;

				await this.apiService
					.checkSlotAvailability(
						this.selectedDepartment,
						this.selectedSlot.start
					)
					.then((res: any) => {
						slotAvailable = res.available;
					});

				if (slotAvailable === false) {
					// If unavailable, then alert user
					this.alertService.error(
						this.translateService.instant('SUMMARY.INVALID_SLOT')
					);
					this.scrollToTop();
					this.slotAvailable = false;
					this.spinner.hide();
					this.checkoutStarted = false;
				} else {
					// If available then checkout
					// this.checkout()
					await this.telephonePayment();
				}
			}
		} else {
			this.checkoutStarted = true;
			this.spinner.show();

			try {
				const priceData = await this.preCheckoutExtras();
				console.log('priceData', priceData);
				await this.preBasketPayment(priceData.paymentAmount, false);
			} catch (err) {
				console.error(err);
				this.spinner.hide();
				this.checkoutStarted = false;
			}
		}
	}

	async adminCheckout() {
		this.alertService.clear();
		this.adminFormSubmitted = true;
		let noNotifications = true;

		const customerDetailsValue = this.datastoreService.customerDetailsForm;

		const params = {
			first_name: customerDetailsValue.controls.first_name.value,
			last_name: customerDetailsValue.controls.last_name.value,
			email: customerDetailsValue.controls.email_address.value,
			mobile: customerDetailsValue.controls.contact_number.value,
			// mobile: customerDetailsValue.controls.mobile_number.value,
			// postcode: customerDetailsValue.postcode,
			// .trim()
			// .replace(" ", ""),
			member_type: '2',
			send_welcome_email: false,
		};
		let clientRes;
		const found: any = await this.apiService.getBookingsForUser(
			this.selectedLocation,
			this.selectedDepartment,
			params.email
		);
		if (found == 'User not found') {
			// make the client
			try {
				clientRes = await this.selectedDepartment.$post('client', {}, params);
				if (clientRes) {
					this.datastoreService.client = clientRes;
					console.log('datastore client', this.datastoreService.client);
					this.datastoreService.clientCreated = true;
				}
			} catch (err) {
				console.error(err);
			}
		} else {
			// get teh clients ID
			console.log(found);
			this.datastoreService.client = found;
			// this.memberService.setMember(found);
		}
		try {
			await this.addItem();
		} catch (err) {
			// addItem() has already surfaced the error to the customer. Do not fall through:
			// the service item can still hold whatever resource JRNI auto-assigned, which is
			// exactly how bookings land on the wrong resource.
			console.error('Aborting checkout — service item update failed', err);
			this.checkoutStarted = false;
			this.spinner.hide();
			return;
		}

		if (
			this.departmentService.selectedDepartment.hasOwnProperty('extra') &&
			this.departmentService.selectedDepartment.extra.hasOwnProperty(
				'login_required'
			)
		) {
			this.departmentService.selectedDepartment.extra.login_required.toLowerCase() ===
				'yes'
				? (this.member = await this.memberService.getMember())
				: (this.member = await this.datastoreService.client);
		} else {
			this.member = await this.datastoreService.client;
		}

		// if (!this.datastoreService.adminJourney && this.datastoreService.selectedService.extra?.online_payment == 'Yes') {
		noNotifications = true;
		// }

		if (this.datastoreService.adminJourney) {
			await this.basketService
				.checkoutBasketV1(this.selectedLocation, this.member, noNotifications)
				.then(async (res: any) => {
					// Get the purchase
					await this.afterCheckout(res);
				})
				.catch((error: HttpErrorResponse) => {
					console.log(error);
					if (error['response'].status === 409) {
						this.alertService.error(
							this.translateService.instant('SUMMARY.INVALID_SLOT')
						);
					} else {
						this.alertService.error(
							this.translateService.instant('COMMON.LOAD_ISSUE')
						);
					}
					this.spinner.hide();
					this.checkoutStarted = false;
					this.scrollToTop();
				});
		} else {
			try {
				const checkout = await this.apiService.basketCheckout(
					this.selectedLocation,
					this.basketService.currentBasket,
					this.datastoreService.client
				);
				await this.afterCheckout(checkout);
			} catch (error) {
				console.error(error);
				if (error['response'].status === 409) {
					this.alertService.error(
						this.translateService.instant('SUMMARY.INVALID_SLOT')
					);
				} else {
					this.alertService.error(
						this.translateService.instant('COMMON.LOAD_ISSUE')
					);
				}
				this.spinner.hide();
				this.checkoutStarted = false;
				this.scrollToTop();
			}
		}
	}

	async postBasketCheckout(company, basket, client) {
		if (isNaN(this.datastoreService.totalCost)) {
			this.datastoreService.totalCost = 0;
		}
		const checkout: any = await this.apiService.basketCheckout(
			company,
			basket,
			{ id: client.id }
		);

		console.log(checkout);
		const purchase: any = await this.apiService.findPurchase(
			this.selectedLocation,
			checkout.id
		);
		console.log(purchase);

		const booking = purchase._embedded.bookings[0];
		const member = purchase._embedded.client;
		this.member = member;
		this.datastoreService.booking = booking;
		this.datastoreService.purchase = purchase;
		console.log(booking);

		/// schema questions 
		const selectedSchema = this.datastoreService.selectedSchema;
		const metaData = {
			revision: this.datastoreService.serviceQuestionSchema[selectedSchema].revision,
			data: this.datastoreService.bookingAnswers,
		}
		const save = await this.apiService.addMetadataToBooking(booking.company_id, booking.id, 'booking_questions', metaData);

		// await this.apiService.sendFrontSheetEmail(booking); // sendCommunicationEmail
		let ceremonyFee;
		try {
			if (this.datastoreService.serviceFees.length > 0) {
				// find ceremony base cost
				const noQuestionId = this.datastoreService.serviceFees.find(
					(item) => item.questionid == undefined
				);
				console.log('noQuestionId', noQuestionId);
				if (noQuestionId) {
					ceremonyFee = noQuestionId;
					// remove the base cost from the array
					this.datastoreService.serviceFees =
						this.datastoreService.serviceFees.filter(
							(item) => item.questionid !== undefined
						);
				}
			}

			if (!ceremonyFee) {
				ceremonyFee = { cost: 0 };
			}

			console.log('ceremonyFee', ceremonyFee);

			// ceremonyFee = this.datastoreService.serviceFees.shift();
		} catch (err) {
			console.log(err);
		}

		let paymentAmount = 0;
		let bookingPrice = 0;
		let chargePrice = 0;
		let certs = 0;
		let foundExtraItemIds = [];
		let foundExtraItemCharges = [];

		let certsToRemoveCount = 0;

		try {
			// link booking to extra item ONLY IF we are not an admin journey, but we always want to calculate the price.
			if (this.datastoreService.config.hasOwnProperty('journey_config')) {
				if (
					this.datastoreService.config.journey_config.hasOwnProperty(
						'appointments'
					)
				) {
					// if (this.datastoreService.config.journey_config.ceremonies.hasOwnProperty('fees_extra_item_id')) {
					//   const extraItem = this.datastoreService.config.journey_config.ceremonies.fees_extra_item_id.trim();
					//   await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem, ceremonyFee);
					// }
					if (this.datastoreService.selectedService.extra?.fees_extra_item_id) {
						const extraItem =
							this.datastoreService.selectedService.extra?.fees_extra_item_id.trim();
						if (extraItem && extraItem.length > 0) {
							// paymentAmount += ceremonyFee.deposit;
							// paymentAmount = this.datastoreService.totalCost;
							bookingPrice += ceremonyFee.cost;
							// if (!this.adminJourney) {
							await this.apiService.linkExtraItem(
								this.selectedLocation.id,
								this.datastoreService.selectedService.id,
								booking.id,
								extraItem,
								ceremonyFee
							);
							// }
						}
					}
					// now link other items
					console.log('serviceFees', this.datastoreService.serviceFees);
					for (const extraItem of this.datastoreService.serviceFees) {
						if (extraItem.questionid) {
							const question = this.datastoreService.companyQuestions.find(
								(q) => q.id == extraItem.questionid
							);
							if (question) {
								if (question.help_text) {
									const schema: any = JSON.parse(question.help_text);
									if (schema['extra-item']) {
										const extraItemId = schema['extra-item'];
										foundExtraItemIds.push(extraItemId);
										foundExtraItemCharges.push(
											extraItem.cost * parseInt(extraItem.quantity)
										);
										// if (question.id == this.datastoreService.config.journey_config.ceremonies.included_certificates_question) {
										// paymentAmount += (extraItem.cost * parseInt(extraItem.quantity));
										// bookingPrice += (extraItem.cost * parseInt(extraItem.quantity));
										// chargePrice += extraItem.cost;
										bookingPrice +=
											extraItem.cost * parseInt(extraItem.quantity);
										// bookingPrice += extraItem.cost;
										// }
										certs++;
										// Always link extra items
										// if (!this.adminJourney) {
										await this.apiService.linkExtraItem(
											this.selectedLocation.id,
											this.datastoreService.selectedService.id,
											booking.id,
											extraItemId,
											extraItem
										);
										// }
									} else {
										console.log('Missing extra item');
									}
								} else {
									console.log('Missing schema');
								}
							} else {
								console.log(`Cant find question ${extraItem.questionid}`);
								chargePrice += extraItem.cost;
								bookingPrice += extraItem.cost * parseInt(extraItem.quantity);
								await this.apiService.linkExtraItem(
									this.selectedLocation.id,
									this.datastoreService.selectedService.id,
									booking.id,
									extraItem.item_id,
									extraItem
								);
							}
						} else {
							console.log('No question ID on extra item');
							chargePrice += extraItem.cost;
							bookingPrice += extraItem.cost * parseInt(extraItem.quantity);
							await this.apiService.linkExtraItem(
								this.selectedLocation.id,
								this.datastoreService.selectedService.id,
								booking.id,
								extraItem.item_id,
								extraItem
							);
						}
					}
				}
			}
		} catch (err) {
			console.log(err);
		}

		if (this.datastoreService.selectedService.extra?.online_payment == 'Yes') {
			try {
				console.log(`Booking price: ${bookingPrice}`);
				// now we update the price of the booking
				await this.apiService.updatePrice(
					this.selectedLocation,
					booking.id,
					purchase.id,
					`${bookingPrice * 100}`,
					'0'
				);

				localStorage.setItem('booking', JSON.stringify(booking));
				// set the resource, the date time and the location, the booking all on localstorage
				// localStorage.setItem('resource', JSON.stringify(this.selectedResourceObj));
				localStorage.setItem('date', JSON.stringify(this.selectedSlot));
				localStorage.setItem('location', JSON.stringify(this.selectedLocation));
				localStorage.setItem('booking', JSON.stringify(booking));
				localStorage.setItem('service', JSON.stringify(this.selectedService));

				const authToken: string = localStorage.getItem('auth_token');
				console.log('authToken', authToken);
				const extra: any =
					await this.apiService.getServiceItemExtraLinksForBooking(
						booking.company_id,
						booking.id,
						authToken,
						this.member.id
					);
				console.log(extra);
				let payCallNote = '';
				let note = `Payment type: `;
				let hasDeposit = false;
				if (extra && extra.length > 0) {
					for (const item of extra) {
						if (
							item.item_id !==
							this.datastoreService.selectedService.extra?.fees_extra_item_id
						) {
							if (item.data && item.data.quantity) {
								certs = parseInt(item.data?.quantity);
							}
							break;
						}
					}
					for (const item of extra) {
						if (
							item.item_id ===
							this.datastoreService.selectedService.extra?.fees_extra_item_id
						) {
							// now we know the deposit and full fee value
							if (item.data.deposit !== item.data.cost) {
								const daysAway = moment(booking.datetime).diff(moment(), 'd');
								if (daysAway > 182) {
									note = `${note} Ceremony Fee Deposit`;
									payCallNote = `Ceremony Fee Deposit`;
									if (certs > 0) {
										note = `${note} & Certificates in Full`;
										payCallNote = `${payCallNote} & Certificates in Full`;
									}
									hasDeposit = true;
								} else {
									note = `${note} Ceremony Fee`;
									payCallNote = `Ceremony Fee`;
									if (certs > 0) {
										note = `${note} & Certificates in Full`;
										payCallNote = `${payCallNote} & Certificates in Full`;
									}
								}
							} else {
								note = `${note} Ceremony Fee`;
								payCallNote = `Ceremony Fee`;
								if (certs > 0) {
									note = `${note} & Certificates in Full`;
									payCallNote = `${payCallNote} & Certificates in Full`;
								}
							}
						}
					}
				}
				// now update the note
				note += ` | Deposit? ${hasDeposit ? 'Yes' : 'No'}`;
				if (certs > 0) {
					note += ` | Number of certificates: ${certs}`;
				}
				note += ` | Deposit payment date: ${moment()
					.tz('Europe/London')
					.format('dddd, MMMM Do YYYY')}`;
				try {
					if (bookingPrice > 0) {
						await this.apiService.payPurchase(
							this.selectedLocation.id,
							booking.service_id,
							booking.purchase_id,
							{
								amount: bookingPrice,
								transaction_id: ``,
								notify: false,
								notify_admin: false,
								payment_status: 'paid',
								notes: `${payCallNote}`,
							},
							booking._embedded.client.id
						);
					}
				} catch (err) {
					console.error(err);
				}

				try {
					await this.apiService
						.addNoteToBooking(this.selectedLocation, booking.id, note)
						.then(async (body: any) => {
							// Loop over booking.questions and attach images for base64 answers
							for (const key in body.questions) {
								if (body.questions.hasOwnProperty(key)) {
									const question = body.questions[key];

									if (
										question.answer &&
										typeof question.answer === 'string' &&
										question.answer.startsWith('data:image/')
									) {
										try {
											await this.basketService.attachImageToBooking(
												body.purchase_ref,
												body.id,
												question.answer
											);
											console.log(
												`Attached image for question: ${question.name}`
											);
										} catch (error) {
											console.error(
												`Error attaching image for question: ${question.name}`,
												error
											);
										}
									}
								}
							}
						});
				} catch (err) {
					console.error(err);
				}

				try {
					const config: any = this.config;
					if (
						config &&
						config.journey_config &&
						config.journey_config.hasOwnProperty('crm_push')
					) {
						if (config.journey_config.crm_push === 'osc') {
							await this.apiService.submitCaseToOracle(
								this.selectedDepartment,
								booking
							);
						}
					}
				} catch (err) {
					console.error(err);
				}

				// try {
				// 	const dontSendIds =
				// 		this.config.journey_config.welcome_email_ignore_list;
				// 	// dont send emails for these ids
				// 	if (dontSendIds &&
				// 		!dontSendIds.includes(
				// 			this.datastoreService.selectedService.global_id
				// 		)
				// 	) {
				// 		// if (!this.datastoreService.isCitizenshipRoute) {
				// 		// 	await this.apiService.sendWelcomeEmail(
				// 		// 		this.selectedLocation.id,
				// 		// 		member.id
				// 		// 	);
				// 		// }
				// 		// await this.apiService.bookingTimeline(
				// 		// 	this.selectedLocation.id,
				// 		// 	booking.purchase_id,
				// 		// 	member.id,
				// 		// 	member.email
				// 		// );
				// 	}
				// } catch (err) {
				// 	console.error(err);
				// }

				this.spinner.hide();
				this.router.navigate(['confirmation']);
				return;
			} catch (err) {
				console.error(err);
				this.spinner.hide();
				// this.apiService.logPaymentExtra(
				//   this.company,
				//   this.dataStore.selectedService,
				//   booking.purchase_id,
				//   {
				//     "purchase": booking.purchase_id,
				//     "payment_error": err
				//   }
				// );
				this.alertService.error(this.translateService.instant('PAYMENT.ERROR'));
				this.router.navigate(['locations']);
			}
		}
	}

	async afterCheckout(res) {
		console.log(res);
		const purchase: any = await this.apiService.findPurchase(
			this.selectedLocation,
			res.id
		);
		console.log(purchase);

		const booking = purchase._embedded.bookings[0];
		this.datastoreService.booking = booking;
		this.datastoreService.purchase = purchase;
		//
		console.log(booking);

		// await this.apiService.sendFrontSheetEmail(booking); // sendCommunicationEmail
		let ceremonyFee;
		try {
			if (this.datastoreService.serviceFees.length > 0) {
				// find ceremony base cost
				const noQuestionId = this.datastoreService.serviceFees.find(
					(item) => item.questionid == undefined
				);
				console.log('noQuestionId', noQuestionId);
				if (noQuestionId) {
					ceremonyFee = noQuestionId;
					// remove the base cost from the array
					this.datastoreService.serviceFees =
						this.datastoreService.serviceFees.filter(
							(item) => item.questionid !== undefined
						);
				}
			}

			// ceremonyFee = this.datastoreService.serviceFees.shift();
		} catch (err) {
			console.log(err);
		}
		console.log(
			'this.datastoreService.adminJourney',
			this.datastoreService.adminJourney,
			'this.datastoreService.selectedService.extra?.online_payment',
			this.datastoreService.selectedService.extra?.online_payment,
			'this.datastoreService.serviceFees',
			this.datastoreService.serviceFees,
			'ceremonyFee',
			ceremonyFee
		);
		let paymentAmount = 0;
		let bookingPrice = 0;
		let chargePrice = 0;
		let certs = 0;
		const foundExtraItemIds = [];
		const foundExtraItemCharges = [];

		let certsToRemoveCount = 0;
		if (this.adminJourney) {
			const certsToRemove = this.adminForm.controls['certificate_removal'];
			if (parseInt(certsToRemove.value) > 0) {
				console.log(`We should remove ${certsToRemove.value} certificates`);
				certsToRemoveCount = parseInt(certsToRemove.value);
			}
		}

		try {
			// link booking to extra item ONLY IF we are not an admin journey, but we always want to calculate the price.
			if (this.datastoreService.config.hasOwnProperty('journey_config')) {
				if (
					this.datastoreService.config.journey_config.hasOwnProperty(
						'ceremonies'
					)
				) {

					if (this.datastoreService.selectedService.extra?.fees_extra_item_id) {
						const extraItem =
							this.datastoreService.selectedService.extra?.fees_extra_item_id.trim();
						if (extraItem && extraItem.length > 0) {
							// paymentAmount += ceremonyFee.deposit;
							// paymentAmount = this.datastoreService.totalCost;
							bookingPrice += ceremonyFee.cost;
							// if (!this.adminJourney) {
							await this.apiService.linkExtraItem(
								this.selectedLocation.id,
								this.datastoreService.selectedService.id,
								booking.id,
								extraItem,
								ceremonyFee
							);
							// }
						}
					}
					// now link other items
					console.log('serviceFees', this.datastoreService.serviceFees);
					for (const extraItem of this.datastoreService.serviceFees) {
						if (extraItem.questionid) {
							const question = this.datastoreService.companyQuestions.find(
								(q) => q.id == extraItem.questionid
							);
							if (question) {
								if (question.help_text) {
									const schema: any = JSON.parse(question.help_text);
									if (schema['extra-item']) {
										const extraItemId = schema['extra-item'];
										foundExtraItemIds.push(extraItemId);
										foundExtraItemCharges.push(
											extraItem.cost * parseInt(extraItem.quantity)
										);

										bookingPrice +=
											extraItem.cost * parseInt(extraItem.quantity);
										// bookingPrice += extraItem.cost;
										// }
										certs++;
										// Always link extra items
										// if (!this.adminJourney) {
										await this.apiService.linkExtraItem(
											this.selectedLocation.id,
											this.datastoreService.selectedService.id,
											booking.id,
											extraItemId,
											extraItem
										);
										// }
									} else {
										console.log('Missing extra item');
									}
								} else {
									console.log('Missing schema');
								}
							} else {
								console.log(`Cant find question ${extraItem.questionid}`);
								chargePrice += extraItem.cost;
								bookingPrice += extraItem.cost * parseInt(extraItem.quantity);
								await this.apiService.linkExtraItem(
									this.selectedLocation.id,
									this.datastoreService.selectedService.id,
									booking.id,
									extraItem.item_id,
									extraItem
								);
							}
						} else {
							console.log('No question ID on extra item');
							chargePrice += extraItem.cost;
							bookingPrice += extraItem.cost * parseInt(extraItem.quantity);
							await this.apiService.linkExtraItem(
								this.selectedLocation.id,
								this.datastoreService.selectedService.id,
								booking.id,
								extraItem.item_id,
								extraItem
							);
						}
					}
				}
			}
		} catch (err) {
			console.log(err);
		}

		if (
			!this.datastoreService.adminJourney &&
			this.datastoreService.selectedService.extra?.online_payment == 'Yes' &&
			ceremonyFee &&
			ceremonyFee.hasOwnProperty('deposit')
		) {
			try {
				console.log(`Booking price: ${bookingPrice}`);
				// now we update the price of the booking
				await this.apiService.updatePrice(
					this.selectedLocation,
					booking.id,
					purchase.id,
					`${bookingPrice * 100}`,
					'0'
				);

				localStorage.setItem('booking', JSON.stringify(booking));
				// set the resource, the date time and the location, the booking all on localstorage
				localStorage.setItem(
					'resource',
					JSON.stringify(this.selectedResourceObj)
				);
				localStorage.setItem('date', JSON.stringify(this.selectedSlot));
				localStorage.setItem('location', JSON.stringify(this.selectedLocation));
				localStorage.setItem('booking', JSON.stringify(booking));
				localStorage.setItem('service', JSON.stringify(this.selectedService));
				const extraItemId =
					this.datastoreService.selectedService.extra?.fees_extra_item_id.trim();
				let extraItem;
				const extraItemBonus = [];
				try {
					extraItem = await this.apiService.getExtraItem(
						booking.company_id,
						this.selectedService.global_id,
						extraItemId
					);
					for (let i in foundExtraItemIds) {
						res = await this.apiService.getExtraItem(
							booking.company_id,
							this.selectedService.global_id,
							foundExtraItemIds[i]
						);
						if (res) {
							res.chargePrice = foundExtraItemCharges[i];
							extraItemBonus.push(res);
						}
					}
				} catch (err) {
					console.error(err);
				}
				console.log('extraItems');
				console.log(extraItem);
				console.log(extraItemBonus);

			} catch (err) {
				console.error(err);

				this.basketService.deleteAllBaskets(this.selectedLocation);
				this.spinner.hide();
				this.checkoutStarted = false;
			}
		} else {
			// now we update the price of the booking
			const extraItems = [];
			if (foundExtraItemIds) {
				for (const foundExtraItemId of foundExtraItemIds) {
					const extraItem = await this.apiService.getExtraItem(
						booking.company_id,
						this.datastoreService.selectedService.global_id,
						foundExtraItemId
					);
					extraItems.push(extraItem);
				}
			}
			let note = `Payment type: `;
			let payCallNote = '';
			let hasDeposit = false;
			const authToken: string = localStorage.getItem('auth_token');
			console.log('authToken', authToken);
			const extra: any =
				await this.apiService.getServiceItemExtraLinksForBooking(
					booking.company_id,
					booking.id,
					authToken,
					this.member.id
				);

			if (extra && extra.length > 0) {
				for (const item of extra) {
					if (
						item.item_id !==
						this.datastoreService.selectedService.extra?.fees_extra_item_id
					) {
						if (item.data && item.data.quantity) {
							certs = parseInt(item.data?.quantity);
						}
						break;
					}
				}
				for (const item of extra) {
					if (
						item.item_id ===
						this.datastoreService.selectedService.extra?.fees_extra_item_id
					) {
						// now we know the deposit and full fee value
						if (item.data.deposit !== item.data.cost) {
							// const ceremonyDate = moment(this.booking.datetime);
							const daysAway = moment(booking.datetime).diff(moment(), 'd');
							if (daysAway > 182) {
								note = `${note} Ceremony Fee Deposit`;
								payCallNote = `Ceremony Fee Deposit`;
								if (certs > 0) {
									note = `${note} & Certificates in Full`;
									payCallNote = `${payCallNote} & Certificates in Full`;
								}
								hasDeposit = true;
							} else {
								note = `${note} Ceremony Fee`;
								payCallNote = `Ceremony Fee`;
								if (certs > 0) {
									note = `${note} & Certificates in Full`;
									payCallNote = `${payCallNote} & Certificates in Full`;
								}
							}
						} else {
							note = `${note} Ceremony Fee`;
							payCallNote = `Ceremony Fee`;
							if (certs > 0) {
								note = `${note} & Certificates in Full`;
								payCallNote = `${payCallNote} & Certificates in Full`;
							}
						}
					}
				}
			}

			note = `${note} ${this.form.note.value}`;
			payCallNote = `${this.form.note.value}`;

			note += ` | Deposit? ${hasDeposit ? 'Yes' : 'No'}`;
			if (certs > 0 && extraItems) {
				for (const extraItem of extraItems) {
					note += `| Selected available extra: ${extraItem.item_name}`;
				}
				note += ` | Quantity: ${certs}`;
			}
			note += ` | Deposit payment date: ${moment()
				.tz('Europe/London')
				.format('dddd, MMMM Do YYYY')}`;
			note += ` | Deposit payment amount: £${parseFloat(
				this.form.amount.value
			)}`;
			note += ` | Deposit receipt number: ${this.form.reference.value}`;

			console.log(this.form);

			try {
				await this.apiService.updatePrice(
					this.selectedLocation,
					booking.id,
					booking.purchase_id,
					`${bookingPrice * 100}`,
					`0`
				);
				await this.apiService.payPurchase(
					this.selectedLocation.id,
					booking.service_id,
					booking.purchase_id,
					{
						amount: parseFloat(this.form.amount.value),
						transaction_id: `${this.form.reference.value}`,
						notify: false,
						notify_admin: false,
						payment_status: 'paid',
						notes: `${payCallNote}`,
					},
					booking._embedded.client.id
				);
				await this.apiService
					.addNoteToBooking(this.selectedLocation, booking.id, note)
					.then(async (body: any) => {
						// Loop over booking.questions and attach images for base64 answers
						for (const key in body.questions) {
							if (body.questions.hasOwnProperty(key)) {
								const question = body.questions[key];

								if (
									question.answer &&
									typeof question.answer === 'string' &&
									question.answer.startsWith('data:image/')
								) {
									try {
										await this.basketService.attachImageToBooking(
											body.purchase_ref,
											body.id,
											question.answer
										);
										console.log(
											`Attached image for question: ${question.name}`
										);
									} catch (error) {
										console.error(
											`Error attaching image for question: ${question.name}`,
											error
										);
									}
								}
							}
						}
					});
			} catch (err) {
				console.error(err);
			}

			if (this.datastoreService.clientCreated) {
				this.datastoreService.clientCreated = false;
			}
			// set the resource, the date time and the location, the booking all on localstorage
			localStorage.setItem(
				'resource',
				JSON.stringify(this.selectedResourceObj)
			);
			localStorage.setItem('date', JSON.stringify(this.selectedSlot));
			localStorage.setItem('location', JSON.stringify(this.selectedLocation));
			localStorage.setItem('booking', JSON.stringify(booking));
			localStorage.setItem('service', JSON.stringify(this.selectedService));
			this.router.navigate(['/confirmation']);
		}
	}

	async telephonePayment() {
		this.checkoutStarted = true;
		this.spinner.show();

		// Check if selected slot is still available
		let slotAvailable: boolean;

		await this.apiService
			.checkSlotAvailability(this.selectedDepartment, this.selectedSlot.start)
			.then((res: any) => {
				slotAvailable = res.available;
			});

		if (slotAvailable === false) {
			// If unavailable, then alert user
			this.alertService.error(
				this.translateService.instant('SUMMARY.INVALID_SLOT')
			);
			this.scrollToTop();
			this.slotAvailable = false;
			this.spinner.hide();
			this.checkoutStarted = false;
		} else {
			// If available then checkout
			// this.checkout()
			try {
				const priceData = await this.preCheckoutExtras();
				console.log('priceData', priceData);
				await this.preBasketPayment(priceData.paymentAmount, true);
			} catch (err) {
				console.error(err);
			}
		}
	}

	async preCheckoutExtras() {
		try {
			if (this.datastoreService.serviceFees.length > 0) {
				// find ceremony base cost
				console.log('serviceFees', this.datastoreService.serviceFees);
				const noQuestionId = this.datastoreService.serviceFees.find(
					(item) => item.questionid == undefined
				);
				console.log('noQuestionId', noQuestionId);
				if (noQuestionId) {
					this.ceremonyFee = noQuestionId;
					// remove the base cost from the array
					this.datastoreService.serviceFees =
						this.datastoreService.serviceFees.filter(
							(item) => item.questionid !== undefined
						);
				}
			}

			// ceremonyFee = this.datastoreService.serviceFees.shift();
		} catch (err) {
			console.log(err);
		}
		console.log(
			'this.datastoreService.adminJourney',
			this.datastoreService.adminJourney,
			'this.datastoreService.selectedService.extra?.online_payment',
			this.datastoreService.selectedService.extra?.online_payment,
			'this.datastoreService.serviceFees',
			this.datastoreService.serviceFees,
			'ceremonyFee',
			this.ceremonyFee
		);
		let paymentAmount = 0;
		let bookingPrice = 0;
		let chargePrice = 0;
		let certs = 0;
		let foundExtraItemIds = [];
		let foundExtraItemCharges = [];
		if (this.ceremonyFee) {
			paymentAmount += this.ceremonyFee.cost;
		}

		let certsToRemoveCount = 0;
		if (this.adminJourney) {
			const certsToRemove = this.adminForm.controls['certificate_removal'];
			if (parseInt(certsToRemove.value) > 0) {
				console.log(`We should remove ${certsToRemove.value} certificates`);
				certsToRemoveCount = parseInt(certsToRemove.value);
			}
		}

		if (!this.datastoreService.isCitizenshipRoute) {
			try {
				// link booking to extra item ONLY IF we are not an admin journey, but we always want to calculate the price.
				if (this.datastoreService.config.hasOwnProperty('journey_config')) {
					if (
						this.datastoreService.config.journey_config.hasOwnProperty(
							'appointments'
						)
					) {

						if (isNaN(this.datastoreService.totalCost)) {
							this.datastoreService.totalCost = 0;
						}
						if (this.datastoreService.selectedService.extra?.fees_extra_item_id) {
							const extraItem =
								this.datastoreService.selectedService.extra?.fees_extra_item_id.trim();
							if (extraItem && extraItem.length > 0) {
								// paymentAmount += ceremonyFee.deposit;
								console.log('paymentAmount', paymentAmount);
								// paymentAmount = this.datastoreService.totalCost;
								if (isNaN(paymentAmount)) {
									paymentAmount = 0;
								}
								if (!this.ceremonyFee) {
									this.ceremonyFee = { cost: 0 };
								}

								if (isNaN(this.ceremonyFee.cost)) {
									this.ceremonyFee.cost = 0;
								}
								console.log('this.ceremonyFee.cost', this.ceremonyFee.cost);
								bookingPrice += this.ceremonyFee.cost;
								console.log('bookingPrice', bookingPrice);
								this.bookingPrice = bookingPrice;
								// if (!this.adminJourney) {
								// await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem, ceremonyFee);
								// }
							}
						}
						// now link other items
						console.log('serviceFees', this.datastoreService.serviceFees);
						for (const extraItem of this.datastoreService.serviceFees) {
							if (extraItem.questionid) {
								console.log(this.datastoreService);
								const question = this.datastoreService.serviceQuestionSchema[this.datastoreService.selectedSchema].schema.fields.find(
									(q) => q.field == extraItem.questionid
								);
								if (question) {
									console.log('question', question);
									if (question.hasOwnProperty('extra-item') && question['extra-item']) {
										const extraItemId = question['extra-item'];
										foundExtraItemIds.push(extraItemId);
										foundExtraItemCharges.push(
											extraItem.cost * parseInt(extraItem.quantity)
										);
										bookingPrice +=
											extraItem.cost * parseInt(extraItem.quantity);
										// bookingPrice += extraItem.cost;
										console.log('ei bookingPrice', bookingPrice);
										paymentAmount +=
											extraItem.cost * parseInt(extraItem.quantity);
										console.log('ei paymentAmount', paymentAmount);
										// }
										certs++;
									}
									else if (extraItem.item_id) {
										// resource_ids path: question has no direct extra-item key but fee has a valid item_id
										console.log('[preCheckoutExtras] resource_ids fee - adding to paymentAmount via item_id', extraItem.item_id);
										foundExtraItemIds.push(extraItem.item_id);
										foundExtraItemCharges.push(extraItem.cost * parseInt(extraItem.quantity));
										bookingPrice += extraItem.cost * parseInt(extraItem.quantity);
										paymentAmount += extraItem.cost * parseInt(extraItem.quantity);
										certs++;
									}
									else {
										console.log('question missing extra-item and no item_id', question);
									}
								} else {
									console.log(`Cant find question ${extraItem.questionid}`);
									chargePrice += extraItem.cost;
									bookingPrice += extraItem.cost * parseInt(extraItem.quantity);
									// await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem.item_id, extraItem);
								}
							} else {
								console.log('No question ID on extra item');
								chargePrice += extraItem.cost;
								bookingPrice += extraItem.cost * parseInt(extraItem.quantity);
								// await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem.item_id, extraItem);
							}
						}
					}
				}
				return {
					paymentAmount,
					bookingPrice,
				};
			} catch (err) {
				console.log(err);
			}
		}
		else {
			// citizenship
			try {
				this.ceremonyFee.item_id = this.datastoreService.citizenshipExtraItem.item_id;
				console.log('totalCost', this.datastoreService.totalCost);
				if (isNaN(this.datastoreService.totalCost)) {
					this.datastoreService.totalCost = 0;
				}

				if (isNaN(paymentAmount)) {
					paymentAmount = 0;
				}
				if (isNaN(this.ceremonyFee.cost)) {
					this.ceremonyFee.cost = 0;
				}
				console.log('this.ceremonyFee.cost', this.ceremonyFee.cost);
				bookingPrice += this.ceremonyFee.cost;
				console.log('bookingPrice', bookingPrice);
				this.bookingPrice = bookingPrice;

				// now link other items

				console.log('serviceFees', this.datastoreService.serviceFees);
				for (const extraItem of this.datastoreService.serviceFees) {
					if (extraItem.questionid) {
						const question = this.datastoreService.serviceQuestionSchema[this.datastoreService.selectedSchema].schema.fields.find(
							(q) => q.field == extraItem.questionid
						);
						if (question) {
							console.log('question', question);
							if (question.hasOwnProperty('extra-item') && question['extra-item']) {
								const extraItemId = question['extra-item'];
								foundExtraItemIds.push(extraItemId);
								foundExtraItemCharges.push(
									extraItem.cost * parseInt(extraItem.quantity)
								);
								bookingPrice +=
									extraItem.cost * parseInt(extraItem.quantity);
								console.log('ei bookingPrice', bookingPrice);
								paymentAmount +=
									extraItem.cost * parseInt(extraItem.quantity);
								console.log('ei paymentAmount', paymentAmount);
								certs++;
							}
							else if (extraItem.item_id) {
								// resource_ids path: question has no direct extra-item key but fee has a valid item_id
								console.log('[preCheckoutExtras] citizenship resource_ids fee - adding via item_id', extraItem.item_id);
								foundExtraItemIds.push(extraItem.item_id);
								foundExtraItemCharges.push(extraItem.cost * parseInt(extraItem.quantity));
								bookingPrice += extraItem.cost * parseInt(extraItem.quantity);
								paymentAmount += extraItem.cost * parseInt(extraItem.quantity);
								certs++;
							}
							else {
								console.log('question missing extra-item and no item_id', question);
							}
						} else {
							console.log(`Cant find question ${extraItem.questionid}`);
							chargePrice += extraItem.cost;
							bookingPrice += extraItem.cost * parseInt(extraItem.quantity);
							// await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem.item_id, extraItem);
						}
					} else {
						console.log('No question ID on extra item');
						chargePrice += extraItem.cost;
						bookingPrice += extraItem.cost * parseInt(extraItem.quantity);
						// await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem.item_id, extraItem);
					}
				}
				return {
					paymentAmount,
					bookingPrice,
				};
			}
			catch (err) {
				console.error(err);
			}
		}
	}

	async preBasketPayment(amount, telephony) {
		// Resolve the PARENT company id (e.g. 37003 appointments, or citizenship parent for
		// citizenship routes) — NOT the child/location company — sent as company_id on the
		// pre-basket call. Falls back to null + warn.
		const parentCompanyId = (this.datastoreService.isCitizenshipRoute
			? AppConfig.settings.core.citizenship_company_id
			: AppConfig.settings.core.company_id) || null;
		if (!parentCompanyId) {
			console.warn('[preBasket] Parent company_id could not be resolved from config; sending company_id as null');
		}
		const clientCreated = await this.createClient(this.adminJourney);
		await new Promise<void>((resolve) => { this.store.asObservable().subscribe(async (state) => {
			console.log('state', state);
			if (state) {
				console.log('client created');
				try {
					await this.addItem();
				} catch (err) {
					// addItem() has already surfaced the error to the customer. Do not fall through:
					// the service item can still hold whatever resource JRNI auto-assigned, which is
					// exactly how bookings land on the wrong resource.
					console.error('Aborting checkout — service item update failed', err);
					this.checkoutStarted = false;
					this.spinner.hide();
					return;
				}
				this.addedItem.asObservable().subscribe(async (item) => {
					if (
						this.departmentService.selectedDepartment.hasOwnProperty('extra') &&
						this.departmentService.selectedDepartment.extra.hasOwnProperty(
							'login_required'
						)
					) {
						this.departmentService.selectedDepartment.extra.login_required.toLowerCase() ===
							'yes'
							? (this.member = await this.memberService.getMember())
							: (this.member = await this.datastoreService.client);
					} else {
						this.member = await this.datastoreService.client;
					}

					const currentBasket = await this.basketService.currentBasket;
					console.log('currentBasket', JSON.stringify(currentBasket));
					const serviceItem = this.basketService.currentServiceItem;
					console.log('serviceItem', serviceItem);

					const authToken = localStorage.getItem('auth_token');

					const tmpFees: any[] = JSON.parse(
						JSON.stringify(this.datastoreService.serviceFees)
					);
					tmpFees.unshift(this.ceremonyFee);
					let journeyRoute = '';
					if (this.datastoreService.journeyRoute) {
						journeyRoute = this.datastoreService.journeyRoute;
					}
					if (this.datastoreService.isCitizenshipRoute) {
						journeyRoute = 'citizenship';
					}
					console.log('journeyRoute', journeyRoute);
					console.log('this.datastoreService.isCitizenshipRoute', this.datastoreService.isCitizenshipRoute);

					console.log(this.selectedService);
					console.log('amount', amount, 'bookingPrice', this.bookingPrice);
					if (amount === 0) {
						amount = amount + this.bookingPrice;
					}
					console.log('Amount + bookingprice = ', amount);
					console.log('service', this.selectedService, this.selectedService.extra, this.selectedService.extra?.short_code);
					if (amount > 0) {
						if (!telephony) {
							const descriptions = [this.selectedService.name];
							let pmtTyp = '';
							let extraItem: any;
							if (!this.datastoreService.isCitizenshipRoute) {
								extraItem = await this.apiService.getExtraItem(
									this.selectedDepartment.id,
									this.selectedService.id,
									this.selectedService.extra?.fees_extra_item_id
								);
								console.log('extraItem', extraItem);
							}
							else {
								extraItem = this.datastoreService.citizenshipExtraItem;
							}
							if (extraItem && extraItem) {
								pmtTyp = extraItem.data.short_code;
							} else {
								pmtTyp =
									this.selectedService.extra &&
										this.selectedService.extra?.short_code
										? this.selectedService.extra?.short_code
										: '';
							}

							const fundCode =
								this.selectedService.extra &&
									this.selectedService.extra?.gl_code
									? this.selectedService.extra?.gl_code
									: '';

							// Civica eStore catalogue id for the payment line. Set per service on
							// the JRNI service `extra.catalogue_id`; when absent bl-civica-api falls
							// back to the SSM BasketCatalogueID for this client.
							const catalogueId = this.selectedService.extra?.catalogue_id;
							const catalogueIds = catalogueId ? [catalogueId] : undefined;

							console.log('this.datastoreService.selectedAddress', this.datastoreService.selectedAddress);

							// Re-show spinner before payment call - the HTTP interceptor hides it on any
							// API error (e.g. getExtraItem), so we must ensure it is visible here
							this.spinner.show();

							// Redbridge takes payment via the Civica eStore PRE-BASKET
							// (book-after-payment) flow, mirroring the live Solihull eStore
							// standard. No booking is created here: bl-civica-api stores the
							// intent + builds the Civica eStore basket and returns it. After
							// payment, the n8n Civica Post-Basket Verify workflow checks out
							// the JRNI basket and links the extra items carried in `data`;
							// verify-payment polls /pre-basket/find until the booking exists.
							try {
								// Single Civica payment line = the total in POUNDS. The itemised
								// fees ride in `data.fees` so the worker links each extra item to
								// the created booking and recomputes the price server-side (base
								// fee = the entry with no questionid).
								const result: any = await this.civicaService.preBasketInvoke(
									this.selectedLocation, // company (child/location)
									this.selectedService,
									currentBasket,
									[{ id: serviceItem.id }],
									descriptions,
									this.member,
									[fundCode], // fund_codes
									[Number(amount) || 0], // amounts (pounds) - single line = total
									authToken,
									{
										fees: tmpFees,
										firstAvailableSlot: this.datastoreService.firstSlotAnalytic ? this.datastoreService.firstSlotAnalytic : "Null",
										lookupResponses: this.datastoreService.lookupResponses,
										selectedAddress: this.datastoreService.selectedAddress,
										schema: this.datastoreService.selectedSchema,
										bookingQuestions: this.datastoreService.bookingAnswers,
										revision: this.datastoreService.serviceQuestionSchema[this.datastoreService.selectedSchema].revision,
									},
									this.selectedSlot,
									this.datastoreService.extraDuration,
									journeyRoute,
									pmtTyp, // reference
									parentCompanyId,
									[1], // quantity - one Civica line
									catalogueIds,
									this.member?.email,
									this.member?.mobile
								);

								if (result && result.url) {
									console.log('REDIR', result);
									window.location.href = result.url;
								} else {
									throw new Error('No redirect URL returned from Civica eStore pre-basket');
								}
							} catch (err) {
								console.error('Civica eStore pre-basket failed', err);
								this.checkoutStarted = false;
								this.checkoutFailed = true;
								//free up the slot
								const cancelled = await this.apiService.deleteBaskets(this.selectedLocation);
								if (!cancelled) {
									console.error('Failed to clear basket after payment failure');
								}
								this.spinner.hide();
								this.scrollToTop();
							}
						} else {
							// get the admin user first
							let pmtTyp = '';
							let extraItem: any;
							if (!this.datastoreService.isCitizenshipRoute) {
								extraItem = await this.apiService.getExtraItem(
									this.selectedDepartment.id,
									this.selectedService.id,
									this.selectedService.extra?.fees_extra_item_id
								);
							}
							else {
								extraItem = this.datastoreService.citizenshipExtraItem;
							}
							if (extraItem) {
								pmtTyp = extraItem.data.pmtTyp;
							} else {
								pmtTyp =
									this.selectedService.extra &&
										this.selectedService.extra?.pmttyp
										? this.selectedService.extra?.pmttyp
										: '';
							}
							// const adminUser = admins._embedded.administrators[0];
							let userRole = 'Administrator';
							let adminUser;
							let adminPhone;
							let userId;
							try {
								adminUser = JSON.parse(localStorage.getItem('agent'));
								console.log('adminUser', adminUser);
								if (adminUser) {
									const adminProfile: any = JSON.parse(
										localStorage.getItem('agent_profile')
									);
									userId = adminProfile.mail.split('@')[0];

									let userRole = adminUser.role;
									if (userRole === 'callcenter') {
										userRole = 'Call Centre';
									} else {
										userRole = 'Administrator';
									}
								}
								else {
									const adminTmp: any = JSON.parse(localStorage.getItem('admin_user'));
									adminUser = {
										id: adminTmp.email,
										email: adminTmp.email
									};
									userRole = 'Administrator';
								}
							}
							catch (err) {
								userRole = 'Administrator';
							}
							if (
								this.selectedDepartment.extra[`hunt_group_number_${userRole}`]
							) {
								adminPhone =
									this.selectedDepartment.extra[
									`hunt_group_number_${userRole}`
									];
							}
							console.log('adminUser', adminUser);

							let journeyRoute = '';
							if (this.datastoreService.journeyRoute) {
								journeyRoute = this.datastoreService.journeyRoute;
							}
							if (this.datastoreService.isCitizenshipRoute) {
								journeyRoute = 'citizenship';
							}

							// const redir: any =
							// 	await this.heyCentricService.preBasketTelephonyInvoke(
							// 		this.selectedLocation,
							// 		currentBasket,
							// 		[serviceItem],
							// 		[this.selectedService.name],
							// 		this.member,
							// 		pmtTyp,
							// 		amount,
							// 		authToken,
							// 		{
							// 			fees: tmpFees,
							// 			lookupResponses: this.datastoreService.lookupResponses,
							// 			selectedAddress: this.datastoreService.selectedAddress
							// 		},
							// 		this.datastoreService.type_of_appointment,
							// 		this.selectedSlot,
							// 		this.datastoreService.extraDuration,
							// 		'M2',
							// 		userId,
							// 		adminUser.email,
							// 		adminPhone,
							// 		journeyRoute
							// 	);

							// if (redir.url) {
							// 	console.log('REDIR', redir);
							// 	window.location = redir.url;
							// 	// this.spinner.hide();
							// } else {
							// 	console.error(`No URL returned from payment gateway`);
							// 	this.alertService.error(
							// 		this.translateService.instant('COMMON.LOAD_ISSUE')
							// 	);
							// 	this.spinner.hide();
							// }
						}
					} else {
						await this.postBasketCheckout(
							this.selectedLocation,
							this.basketService.currentBasket,
							this.member
						);
					}
					resolve();
				});
			} else {
				resolve();
			}
		}); });
	}

	backToCalendar() {
		this.router.navigate(['/calendar']);
	}

	async checkout() {
		this.alertService.clear();
		this.submitted = true;
		let noNotifications = true;

		const clientCreated = await this.createClient(this.adminJourney);
		if (clientCreated) {
			console.log('client created');
			try {
				await this.addItem();
			} catch (err) {
				// addItem() has already surfaced the error to the customer. Do not fall through:
				// the service item can still hold whatever resource JRNI auto-assigned, which is
				// exactly how bookings land on the wrong resource.
				console.error('Aborting checkout — service item update failed', err);
				this.checkoutStarted = false;
				this.spinner.hide();
				return;
			}

			// set member as the client,if the login is not required
			if (
				this.departmentService.selectedDepartment.hasOwnProperty('extra') &&
				this.departmentService.selectedDepartment.extra.hasOwnProperty(
					'login_required'
				)
			) {
				this.departmentService.selectedDepartment.extra.login_required.toLowerCase() ===
					'yes'
					? (this.member = await this.memberService.getMember())
					: (this.member = await this.datastoreService.client);
			} else {
				this.member = await this.datastoreService.client;
			}

			// if (!this.datastoreService.adminJourney && this.datastoreService.selectedService.extra?.online_payment == 'Yes') {
			noNotifications = true;
			// }

			await this.basketService
				.checkoutBasketV1(this.selectedLocation, this.member, noNotifications)
				.then(async (res: any) => {
					// Get the purchase
					const purchase: any = await this.apiService.findPurchase(
						this.selectedLocation,
						res.id
					);
					console.log(purchase);

					const booking = purchase._embedded.bookings[0];
					this.datastoreService.booking = booking;
					this.datastoreService.purchase = purchase;
					//
					console.log(booking);

					// await this.apiService.sendFrontSheetEmail(booking); // sendCommunicationEmail
					let ceremonyFee;
					try {
						if (this.datastoreService.serviceFees.length > 0) {
							// find ceremony base cost
							const noQuestionId = this.datastoreService.serviceFees.find(
								(item) => item.questionid == undefined
							);
							console.log('noQuestionId', noQuestionId);
							if (noQuestionId) {
								ceremonyFee = noQuestionId;
								// remove the base cost from the array
								this.datastoreService.serviceFees =
									this.datastoreService.serviceFees.filter(
										(item) => item.questionid !== undefined
									);
							}
						}

						// ceremonyFee = this.datastoreService.serviceFees.shift();
					} catch (err) {
						console.log(err);
					}
					console.log(
						'this.datastoreService.adminJourney',
						this.datastoreService.adminJourney,
						'this.datastoreService.selectedService.extra?.online_payment',
						this.datastoreService.selectedService.extra?.online_payment,
						'this.datastoreService.serviceFees',
						this.datastoreService.serviceFees,
						'ceremonyFee',
						ceremonyFee
					);
					let paymentAmount = 0;
					let bookingPrice = 0;
					let chargePrice = 0;
					let certs = 0;
					let foundExtraItemIds = [];
					let foundExtraItemCharges = [];

					let certsToRemoveCount = 0;
					if (this.adminJourney) {
						const certsToRemove =
							this.adminForm.controls['certificate_removal'];
						if (parseInt(certsToRemove.value) > 0) {
							console.log(
								`We should remove ${certsToRemove.value} certificates`
							);
							certsToRemoveCount = parseInt(certsToRemove.value);
						}
					}

					try {
						// link booking to extra item ONLY IF we are not an admin journey, but we always want to calculate the price.
						if (this.datastoreService.config.hasOwnProperty('journey_config')) {
							if (
								this.datastoreService.config.journey_config.hasOwnProperty(
									'ceremonies'
								)
							) {
								// if (this.datastoreService.config.journey_config.ceremonies.hasOwnProperty('fees_extra_item_id')) {
								//   const extraItem = this.datastoreService.config.journey_config.ceremonies.fees_extra_item_id.trim();
								//   await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem, ceremonyFee);
								// }
								if (
									this.datastoreService.selectedService.extra
										?.fees_extra_item_id
								) {
									const extraItem =
										this.datastoreService.selectedService.extra?.fees_extra_item_id.trim();
									if (extraItem && extraItem.length > 0) {
										// paymentAmount += ceremonyFee.deposit;
										// paymentAmount = this.datastoreService.totalCost;
										bookingPrice += ceremonyFee.cost;
										// if (!this.adminJourney) {
										await this.apiService.linkExtraItem(
											this.selectedLocation.id,
											this.datastoreService.selectedService.id,
											booking.id,
											extraItem,
											ceremonyFee
										);
										// }
									}
								}
								// now link other items
								console.log('serviceFees', this.datastoreService.serviceFees);
								for (const extraItem of this.datastoreService.serviceFees) {
									if (extraItem.questionid) {
										const question =
											this.datastoreService.companyQuestions.find(
												(q) => q.id == extraItem.questionid
											);
										if (question) {
											if (question.help_text) {
												const schema: any = JSON.parse(question.help_text);
												if (schema['extra-item']) {
													const extraItemId = schema['extra-item'];
													foundExtraItemIds.push(extraItemId);
													foundExtraItemCharges.push(
														extraItem.cost * parseInt(extraItem.quantity)
													);
													// if (question.id == this.datastoreService.config.journey_config.ceremonies.included_certificates_question) {
													// paymentAmount += (extraItem.cost * parseInt(extraItem.quantity));
													// bookingPrice += (extraItem.cost * parseInt(extraItem.quantity));
													// chargePrice += extraItem.cost;
													bookingPrice +=
														extraItem.cost * parseInt(extraItem.quantity);
													// bookingPrice += extraItem.cost;
													// }
													certs++;
													// Always link extra items
													// if (!this.adminJourney) {
													await this.apiService.linkExtraItem(
														this.selectedLocation.id,
														this.datastoreService.selectedService.id,
														booking.id,
														extraItemId,
														extraItem
													);
													// }
												} else {
													console.log('Missing extra item');
												}
											} else {
												console.log('Missing schema');
											}
										} else {
											console.log(`Cant find question ${extraItem.questionid}`);
											chargePrice += extraItem.cost;
											bookingPrice +=
												extraItem.cost * parseInt(extraItem.quantity);
											await this.apiService.linkExtraItem(
												this.selectedLocation.id,
												this.datastoreService.selectedService.id,
												booking.id,
												extraItem.item_id,
												extraItem
											);
										}
									} else {
										console.log('No question ID on extra item');
										chargePrice += extraItem.cost;
										bookingPrice +=
											extraItem.cost * parseInt(extraItem.quantity);
										await this.apiService.linkExtraItem(
											this.selectedLocation.id,
											this.datastoreService.selectedService.id,
											booking.id,
											extraItem.item_id,
											extraItem
										);
									}
								}
							}
						}
					} catch (err) {
						console.log(err);
					}

					if (
						!this.datastoreService.adminJourney &&
						this.datastoreService.selectedService.extra?.online_payment ==
						'Yes' &&
						ceremonyFee &&
						ceremonyFee.hasOwnProperty('deposit')
					) {
						try {
							console.log(`Booking price: ${bookingPrice}`);
							// now we update the price of the booking
							await this.apiService.updatePrice(
								this.selectedLocation,
								booking.id,
								purchase.id,
								`${bookingPrice * 100}`,
								'0'
							);

							localStorage.setItem('booking', JSON.stringify(booking));
							// set the resource, the date time and the location, the booking all on localstorage
							localStorage.setItem(
								'resource',
								JSON.stringify(this.selectedResourceObj)
							);
							localStorage.setItem('date', JSON.stringify(this.selectedSlot));
							localStorage.setItem(
								'location',
								JSON.stringify(this.selectedLocation)
							);
							localStorage.setItem('booking', JSON.stringify(booking));
							localStorage.setItem(
								'service',
								JSON.stringify(this.selectedService)
							);
							const extraItemId =
								this.datastoreService.selectedService.extra?.fees_extra_item_id.trim();
							let extraItem;
							const extraItemBonus = [];
							try {
								extraItem = await this.apiService.getExtraItem(
									booking.company_id,
									this.selectedService.global_id,
									extraItemId
								);
								for (let i in foundExtraItemIds) {
									res = await this.apiService.getExtraItem(
										booking.company_id,
										this.selectedService.global_id,
										foundExtraItemIds[i]
									);
									if (res) {
										res.chargePrice = foundExtraItemCharges[i];
										extraItemBonus.push(res);
									}
								}
							} catch (err) {
								console.error(err);
							}
							console.log('extraItems');
							console.log(extraItem);
							console.log(extraItemBonus);

						} catch (err) {
							console.error(err);

							this.basketService.deleteAllBaskets(this.selectedLocation);
							this.spinner.hide();
							this.checkoutStarted = false;
						}
					} else {

						// now we update the price of the booking
						let extraItems = [];
						if (foundExtraItemIds) {
							for (let foundExtraItemId of foundExtraItemIds) {
								const extraItem = await this.apiService.getExtraItem(
									booking.company_id,
									this.datastoreService.selectedService.global_id,
									foundExtraItemId
								);
								extraItems.push(extraItem);
							}
						}
						let note = `Payment type: `;
						let payCallNote = '';
						let hasDeposit: boolean = false;
						const authToken: string = localStorage.getItem('auth_token');
						console.log('authToken', authToken);
						const extra: any =
							await this.apiService.getServiceItemExtraLinksForBooking(
								booking.company_id,
								booking.id,
								authToken,
								this.member.id
							);

						if (extra && extra.length > 0) {
							for (const item of extra) {
								if (
									item.item_id !==
									this.datastoreService.selectedService.extra
										?.fees_extra_item_id
								) {
									if (item.data && item.data.quantity) {
										certs = parseInt(item.data?.quantity);
									}
									break;
								}
							}
							for (const item of extra) {
								if (
									item.item_id ===
									this.datastoreService.selectedService.extra
										?.fees_extra_item_id
								) {
									// now we know the deposit and full fee value
									if (item.data.deposit !== item.data.cost) {
										// const ceremonyDate = moment(this.booking.datetime);
										const daysAway = moment(booking.datetime).diff(
											moment(),
											'd'
										);
										if (daysAway > 182) {
											note = `${note} Ceremony Fee Deposit`;
											payCallNote = `Ceremony Fee Deposit`;
											if (certs > 0) {
												note = `${note} & Certificates in Full`;
												payCallNote = `${payCallNote} & Certificates in Full`;
											}
											hasDeposit = true;
										} else {
											note = `${note} Ceremony Fee`;
											payCallNote = `Ceremony Fee`;
											if (certs > 0) {
												note = `${note} & Certificates in Full`;
												payCallNote = `${payCallNote} & Certificates in Full`;
											}
										}
									} else {
										note = `${note} Ceremony Fee`;
										payCallNote = `Ceremony Fee`;
										if (certs > 0) {
											note = `${note} & Certificates in Full`;
											payCallNote = `${payCallNote} & Certificates in Full`;
										}
									}
								}
							}
						}
						if (this.adminJourney) {
							note = `${note} ${this.form.note.value}`;
							payCallNote = `${this.form.note.value}`;
						}

						note += ` | Deposit? ${hasDeposit ? 'Yes' : 'No'}`;
						if (certs > 0 && extraItems) {
							for (let extraItem of extraItems) {
								note += `| Selected available extra: ${extraItem.item_name}`;
							}
							note += ` | Quantity: ${certs}`;
						}
						note += ` | Deposit payment date: ${moment()
							.tz('Europe/London')
							.format('dddd, MMMM Do YYYY')}`;
						if (this.adminJourney) {
							note += ` | Deposit payment amount: £${parseFloat(
								this.form.amount.value
							)}`;
							note += ` | Deposit receipt number: ${this.form.reference.value}`;

							console.log(this.form);
						}
						try {
							await this.apiService.updatePrice(
								this.selectedLocation,
								booking.id,
								booking.purchase_id,
								`${bookingPrice * 100}`,
								`0`
							);
							if (this.adminJourney) {
								await this.apiService.payPurchase(
									this.selectedLocation.id,
									booking.service_id,
									booking.purchase_id,
									{
										amount: parseFloat(this.form.amount.value),
										transaction_id: `${this.form.reference.value}`,
										notify: false,
										notify_admin: false,
										payment_status: 'paid',
										notes: `${payCallNote}`,
									},
									booking._embedded.client.id
								);
							}
							await this.apiService
								.addNoteToBooking(this.selectedLocation, booking.id, note)
								.then(async (body: any) => {
									// Loop over booking.questions and attach images for base64 answers
									for (const key in body.questions) {
										if (body.questions.hasOwnProperty(key)) {
											const question = body.questions[key];

											if (
												question.answer &&
												typeof question.answer === 'string' &&
												question.answer.startsWith('data:image/')
											) {
												try {
													await this.basketService.attachImageToBooking(
														body.purchase_ref,
														body.id,
														question.answer
													);
													console.log(
														`Attached image for question: ${question.name}`
													);
												} catch (error) {
													console.error(
														`Error attaching image for question: ${question.name}`,
														error
													);
												}
											}
										}
									}
								});
						} catch (err) {
							console.error(err);
						}

						if (this.datastoreService.clientCreated) {
							this.datastoreService.clientCreated = false;
							try {
								// await this.apiService.sendWelcomeEmail(
								//   this.selectedLocation.id,
								//   this.member.id
								// );
								// await this.apiService.bookingTimeline(
								// 	booking.company_id,
								// 	booking.purchase_id,
								// 	this.member.id,
								// 	this.member.email
								// );
							} catch (err) {
								console.error(err);
							}
						}
						// set the resource, the date time and the location, the booking all on localstorage
						localStorage.setItem(
							'resource',
							JSON.stringify(this.selectedResourceObj)
						);
						localStorage.setItem('date', JSON.stringify(this.selectedSlot));
						localStorage.setItem(
							'location',
							JSON.stringify(this.selectedLocation)
						);
						localStorage.setItem('booking', JSON.stringify(booking));
						localStorage.setItem(
							'service',
							JSON.stringify(this.selectedService)
						);
						this.router.navigate(['/confirmation']);
					}
				})
				.catch((error: HttpErrorResponse) => {
					console.log(error);
					if (error['response'] && error['response'].status === 409) {
						this.alertService.error(
							this.translateService.instant('SUMMARY.INVALID_SLOT')
						);
					} else {
						this.alertService.error(
							this.translateService.instant('COMMON.LOAD_ISSUE')
						);
					}
					this.spinner.hide();
					this.checkoutStarted = false;
					this.scrollToTop();
				});
		}
	}

	formatQuestion(value) {
		// Check if the alue matches the date pattern
		const datePattern = /^\d{4}-\d{2}-\d{2}$/;
		if (datePattern.test(value)) {
			const [year, month, day] = value.split('-');
			return `${day}-${month}-${year}`; // Format as "DD-MM-YYYY"
		}

		// Check if the value is "true" or "false"
		if (value === 'true' || value === true) {
			return 'Yes';
		}
		if (value === 'false' || value === false) {
			return 'No';
		}

		// Return the value as-is for other cases
		return value;
	}

	// Scroll to the top of the page
	scrollToTop() {
		const scrollToOptions = { top: 0, left: 0, behavior: 'instant' };
		window.scrollTo(scrollToOptions as unknown as ScrollToOptions);
	}
}
